import { environment } from 'Public_old/src/environments/environment';

export class RedRobinHelper {
	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	constructor() {}

	public getApiRoot(): string {
		// Adds this check for now until we got a better way to load env
		if (location.hostname.includes('stage-service.visibacare')) {
			return 'https://stage-rr-api.visibacare.com/api';
		}

		if (!environment.production || location.hostname.includes('vcare.pl')) {
			// Find the dev environment string in the url. But in one exception, if
			// the environment string is dev1 then we want to strip the number. But in
			// all other cases we want the number.
			const devEnv = location.hostname.match(/dev[0-9]{2,}|dev[2-9]{1,1}/)?.pop() || 'dev';

			return `https://${devEnv}-rr-api.vcare.pl/api`;
		}

		return 'https://rr-api.visibacare.com/api';
	}
}
